import PackageEditPageTemplate from '~/components/packages/PackageEditPageTemplate';
import { PackageTypes, PackageTypeWords } from '~/lib/PackageHelpers';

const PackageEditPage = ({ initialTab }) => {
    return (
        <PackageEditPageTemplate
            singular={PackageTypeWords[PackageTypes.PACKAGE].singular}
            plural={PackageTypeWords[PackageTypes.PACKAGE].plural}
            basePath="/packages"
            initialTab={initialTab}
        />
    );
};

export default PackageEditPage;
